import { HttpClient } from '@angular/common/http';
import { firstValueFrom, timeout } from 'rxjs';
import { AppConfig } from './app.config';

// ponytail: the version lives in one mutable static (AppConfig.APPVersion), set once here at
// startup from /assets/version.json. This avoids threading a service through the ~7 existing
// AppConfig.APPVersion reads (api-base ×4, display ×2, globals ×1). Upgrade path: promote to an
// injectable VersionService only if a consumer needs to react to version changes at runtime.
export function loadAppVersion(http: HttpClient): () => Promise<void> {
  return async () => {
    try {
      const data = await firstValueFrom(
        http.get<{ version: string }>('assets/version.json').pipe(timeout(3000))
      );
      if (data?.version) {
        AppConfig.APPVersion = data.version;
      }
    } catch {
      // Missing/unreadable version.json (local dev): keep the compiled-in default. Not fatal.
    }
  };
}
